import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { WrapperPreguntaEncuestaSmileys } from './styles';
import IconHappyFaceFull from '../../../assets/img/icon/icon-happy-face-full.svg';
import IconHappyFaceEmpty from '../../../assets/img/icon/icon-happy-face-empty.svg';
import IconSadFaceFull from '../../../assets/img/icon/icon-sad-face-full.svg';
import IconSadFaceEmpty from '../../../assets/img/icon/icon-sad-face-empty.svg';
import IconSeriousFaceFull from '../../../assets/img/icon/icon-serious-face-full.svg';
import IconSeriousFaceEmpty from '../../../assets/img/icon/icon-serious-face-empty.svg';
import IconTooHappyFaceFull from '../../../assets/img/icon/icon-too-happy-face-full.svg';
import IconTooHappyFaceEmpty from '../../../assets/img/icon/icon-too-happy-face-empty.svg';
import IconTooSadFaceFull from '../../../assets/img/icon/icon-too-sad-face-full.svg';
import IconTooSadFaceEmpty from '../../../assets/img/icon/icon-too-sad-face-empty.svg';
import IconVeryHappyFaceFull from '../../../assets/img/icon/icon-very-happy-face-full.svg';
import IconVeryHappyFaceEmpty from '../../../assets/img/icon/icon-very-happy-face-empty.svg';
import IconVerySadFaceFull from '../../../assets/img/icon/icon-very-sad-face-full.svg';
import IconVerySadFaceEmpty from '../../../assets/img/icon/icon-very-sad-face-empty.svg';

const PreguntaEncuestaSmileys = ({ setCalificacionSmiley }) => {
  const iconos = {
    IconTooSadFaceEmpty,
    IconTooSadFaceFull,
    IconVerySadFaceEmpty,
    IconVerySadFaceFull,
    IconSadFaceEmpty,
    IconSadFaceFull,
    IconSeriousFaceEmpty,
    IconSeriousFaceFull,
    IconHappyFaceEmpty,
    IconHappyFaceFull,
    IconVeryHappyFaceEmpty,
    IconVeryHappyFaceFull,
    IconTooHappyFaceEmpty,
    IconTooHappyFaceFull,
  };

  const [iconosNombres, setIconosNombres] = useState([
    'IconTooSadFaceEmpty',
    'IconVerySadFaceEmpty',
    'IconSadFaceEmpty',
    'IconSeriousFaceEmpty',
    'IconHappyFaceEmpty',
    'IconVeryHappyFaceEmpty',
    'IconTooHappyFaceEmpty',
  ]);

  const handleClick = (indice) => {
    let items = [...iconosNombres];
    items = items.map((item) => {
      item = item.replace('Full', 'Empty');
      return item;
    });
    let item = items[indice];
    item = item.endsWith('Empty') ? item.replace('Empty', 'Full') : item.replace('Full', 'Empty');
    items[indice] = item;
    setIconosNombres(items);
    setCalificacionSmiley(indice+1);
  };

  return (
    <WrapperPreguntaEncuestaSmileys>
      <div className="smileysContainer">
        {iconosNombres.map((icono, index) => {
          const width = (100 / iconosNombres.length).toString();
          return (
            <div
              role="button"
              id={icono}
              style={{ width: `${width}%`, textAlign: 'center' }}
              onClick={() => icono.endsWith('Empty') ? handleClick(index) : () => {}}
              onKeyDown={() => () => {}}
              tabIndex={index}
            >
              <img
                className={icono.endsWith('Empty') ? 'smiley' : 'smileyClickeado'}
                src={iconos[iconosNombres[index]]}
                alt="smiley"
              />
              {index === 0 && <p className="smileyTexto">Muy difícil</p>}
              {index === 3 && <p className="smileyTexto">Neutral</p>}
              {index === 6 && <p className="smileyTexto">Muy fácil</p>}
            </div>
          );
        })}
      </div>
    </WrapperPreguntaEncuestaSmileys>
  );
};

PreguntaEncuestaSmileys.propTypes = {
  setCalificacionSmiley: PropTypes.func.isRequired
};

export default PreguntaEncuestaSmileys;
